export interface RRIFilterBy<T> {
  fieldName: string;
  value: T;
  defaultValue: T;
  not?: boolean;
}
